import { put, takeLatest } from "redux-saga/effects";

import { requestFeatureList } from "../../../services/feature";
import {
  fetchFeatureListRequest,
  fetchFeatureListSuccess,
  fetchFeatureListFailure,
} from "../../reducers/feature";

export function* watchFeatureSaga() {
  yield takeLatest(fetchFeatureListRequest, fetchFeatureList);
}


function* fetchFeatureList({ payload }) {
  try {
    const response = yield requestFeatureList(payload);
    yield put(fetchFeatureListSuccess(response));
  } catch (error) {
    yield put(fetchFeatureListFailure("Failed to get list of Leads"));
  }
}
